<div *ngIf="_reload">
  <router-outlet></router-outlet>
  <kla-script *ngIf="customScripts" [config]="customScripts"></kla-script>
</div>
<kla-analytics></kla-analytics>
